import { BirdviewControlOption } from './BirdviewControlOption'

import * as styles from './BirdviewControl.module.css'

function BirdviewControl({ options, value, onChange }) {
  return (
    <div className={styles.control}>
      {options.map(option => (
        <BirdviewControlOption
          isActive={option.value === value}
          key={option.value}
          option={option}
          onSelect={onChange}
        />
      ))}
    </div>
  )
}

export default BirdviewControl
